import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite/no-important';

class Logo extends Component {
  render() {
    const logoSource = (this.props.windowWidth < 840)
      ? '/tmd_recruit/IMG/tmd-logo-small.png'
      : '/tmd_recruit/IMG/tmd-logo-large.png';
    return (
      <div className={css(styles.tmdIconHolder)}>
        <Link to="/">
          <img src={logoSource} className={css(styles.tmdIcon)} alt="logo" />
        </Link>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  tmdIconHolder: {
    alignItems: 'center',
    display: 'flex',
    float: 'left',
    justifyContent: 'center',
    left: 0,
    marginTop: 7,
    '@media only screen and (max-width: 1050px)': {
      marginLeft: 15,
      marginTop: 3,
    },
  },
  tmdIcon: {
    height: 35,
    transition: 'all 0.5s',
    ':hover': {
      filter: 'invert(35%)',
    },
  },
});

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.jsx